import { FC } from 'react';
import { IconProps } from '@/assets/types';

export const MonitorErrorIcon: FC<IconProps> = ({ width = 135, height = 135, ...props }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 135 135' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        transform='translate(18.5625 24.192)'
        d='M23.9062 86.625V78.75L27.8438 74.8125H0V0H97.875V74.8125H70.0312L73.9688 78.75V86.625H23.9062ZM3.9375 70.875H93.9375V3.9375H3.9375V70.875Z'
        fill='var(--color-analog)'
      />
      <path
        transform='translate(56.624 50.124)'
        d='M2.275 22.75L0 20.475L9.1 11.375L0 2.275L2.275 0L11.375 9.1L20.475 0L22.75 2.275L13.65 11.375L22.75 20.475L20.475 22.75L11.375 13.65L2.275 22.75Z'
        fill='var(--color-analog)'
      />
    </svg>
  );
};
